// src/components/common/Card.jsx
// Reusable card component with different variants

import React from 'react';

const Card = ({
  children,
  variant = 'default',
  className = '',
  hover = true,
}) => {
  const baseStyles = 'bg-white rounded-3xl p-8 transition-all text-gray-900';

  const variants = {
    default: 'shadow-lg',
    feature: 'border-3 border-transparent hover:border-pink-500 hover:scale-105',
    pricing: 'border-4 border-transparent hover:border-pink-500 hover:shadow-pink-500/30',
    glass: 'bg-white/90 backdrop-blur-sm',
  };

  const hoverStyles = hover ? 'hover:shadow-2xl' : '';

  return (
    <div className={`${baseStyles} ${variants[variant]} ${hoverStyles} ${className}`}>
      {children}
    </div>
  );
};

export default Card;
